<div *ngIf="isLegalTextExist">
  <div [class]="css">
    <div *ngFor="let item of legalItems.items">
      <div [innerHtml]="item.legalCopy | safeHtml"></div>
    </div>
  </div>
</div>
<div *ngIf="!isLegalTextExist && legalCopy">
  <div [class]="css">
    <div [innerHtml]="legalCopy | safeHtml"></div>
  </div>
</div>
